'use es6';

import { cloneElement } from 'react';
export default ((child, props) => child ? /*#__PURE__*/cloneElement(child, props) : null);